import { Injectable } from "@angular/core";
import { Action } from "@ngrx/store";
import { ActionWithPayload } from "@obg/ngrx-utils";
import { AppError } from "@obg/ngx.core";

import {
	ResetPasswordByEmailAndSecurityQuestionModel,
	ResetPasswordBySmsModel,
	ResetPasswordWithTokenModel,
} from "./login.model";

export const ACTION_PREFIX = "[Login]";
export const LOGIN_ACTION_TYPE = {
	/**
	 * Changes password with forgotPasswordToken received by email after forgot password
	 */
	resetPasswordWithToken: `${ACTION_PREFIX} Reset Password With Token`,
	resetPasswordWithTokenSuccess: `${ACTION_PREFIX} Reset Password With Token Success`,
	resetPasswordWithTokenFail: `${ACTION_PREFIX} Reset Password With Token Fail`,

	resetPasswordByEmail: `${ACTION_PREFIX} Reset Password By Email`,
	resetPasswordByEmailSuccess: `${ACTION_PREFIX} Reset Password By Email Success`,
	resetPasswordByEmailFail: `${ACTION_PREFIX} Reset Password By Email Fail`,

	resetPasswordBySms: `${ACTION_PREFIX} Reset Password By Sms`,
	resetPasswordBySmsSuccess: `${ACTION_PREFIX} Reset Password By Sms Success`,
	resetPasswordBySmsFail: `${ACTION_PREFIX} Reset Password By Sms Fail`,

	resetPasswordByEmailAndSecurityQuestion: `${ACTION_PREFIX} Reset Password By Email And SecurityQuestion`,
	resetPasswordByEmailAndSecurityQuestionSuccess: `${ACTION_PREFIX} Reset Password By Email And SecurityQuestion Success`,
	resetPasswordByEmailAndSecurityQuestionFail: `${ACTION_PREFIX} Reset Password By Email And SecurityQuestion Fail`,
};

@Injectable({
	providedIn: "root",
})
export class LoginAction {
	resetPasswordWithToken(payload: ResetPasswordWithTokenModel): ActionWithPayload {
		return {
			type: LOGIN_ACTION_TYPE.resetPasswordWithToken,
			payload,
		};
	}

	resetPasswordWithTokenSuccess(): Action {
		return {
			type: LOGIN_ACTION_TYPE.resetPasswordWithTokenSuccess,
		};
	}

	resetPasswordWithTokenFail(payload: AppError): ActionWithPayload {
		return {
			type: LOGIN_ACTION_TYPE.resetPasswordWithTokenFail,
			payload,
		};
	}

	resetPasswordByEmail(email: string): ActionWithPayload {
		return {
			type: LOGIN_ACTION_TYPE.resetPasswordByEmail,
			payload: email,
		};
	}

	resetPasswordByEmailSuccess(): Action {
		return {
			type: LOGIN_ACTION_TYPE.resetPasswordByEmailSuccess,
		};
	}

	resetPasswordByEmailFail(payload: AppError): ActionWithPayload {
		return {
			type: LOGIN_ACTION_TYPE.resetPasswordByEmailFail,
			payload,
		};
	}

	resetPasswordBySms(payload: ResetPasswordBySmsModel): ActionWithPayload {
		return {
			type: LOGIN_ACTION_TYPE.resetPasswordBySms,
			payload,
		};
	}

	resetPasswordBySmsSuccess(): Action {
		return {
			type: LOGIN_ACTION_TYPE.resetPasswordBySmsSuccess,
		};
	}

	resetPasswordBySmsFail(payload: AppError): ActionWithPayload {
		return {
			type: LOGIN_ACTION_TYPE.resetPasswordBySmsFail,
			payload,
		};
	}

	resetPasswordByEmailAndSecurityQuestion(payload: ResetPasswordByEmailAndSecurityQuestionModel): ActionWithPayload {
		return {
			type: LOGIN_ACTION_TYPE.resetPasswordByEmailAndSecurityQuestion,
			payload,
		};
	}

	resetPasswordByEmailAndSecurityQuestionSuccess(): Action {
		return {
			type: LOGIN_ACTION_TYPE.resetPasswordByEmailAndSecurityQuestionSuccess,
		};
	}

	resetPasswordByEmailAndSecurityQuestionFail(payload: AppError): ActionWithPayload {
		return {
			type: LOGIN_ACTION_TYPE.resetPasswordByEmailAndSecurityQuestionFail,
			payload,
		};
	}
}
